﻿<!-- App.svelte -->
<script>

    import Api from "./api.js";
    import Header from "./ui/header.svelte";
    

    var api = new Api();
    window.api = api;
    const routeContext = {
        api: api
    }
</script>

<Header {...routeContext}/>


<style type="text/css">
    .app{
        display: flex;
    }
    @media(max-width: 1015px){
        .app{
            flex-direction: column;
        }
    }
</style>